module.exports = __webpack_public_path__ + "static/media/Step3.d16a9da5.svg";